import { render, staticRenderFns } from "./InfoTextInput.vue?vue&type=template&id=3f5f45b7&scoped=true&"
import script from "./InfoTextInput.vue?vue&type=script&lang=js&"
export * from "./InfoTextInput.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/info-text-input.scss?vue&type=style&index=0&id=3f5f45b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f45b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f5f45b7')) {
      api.createRecord('3f5f45b7', component.options)
    } else {
      api.reload('3f5f45b7', component.options)
    }
    module.hot.accept("./InfoTextInput.vue?vue&type=template&id=3f5f45b7&scoped=true&", function () {
      api.rerender('3f5f45b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/Components/InfoTextInput.vue"
export default component.exports